<template>
    <div class="h-pm-5gc-dataQuery-tree">
        <ejs-treeview ref='pmCounterTree' :fields="fieldsOfPmCounterTree" :nodeSelected="nodeSelectedOfPmCounterTree"></ejs-treeview>
    </div>
</template>

<script>
    export default {
        name: "PmCounterManagementLeftTree",
        data(){
            return {
                fieldsOfPmCounterTree: {
                    dataSource: [{ children: [] }],
                    id: 'id',
                    text: 'text',
                    child: 'children',
                    expanded: 'state',
                    tooltip: 'text',
                    htmlAttributes: 'attributes'
                }
            }
        },
        methods: {
            nodeSelectedOfPmCounterTree(counterTreeNode){
                this.$emit('transferSelectedCounterTreeNodeInfo',counterTreeNode);
            },
            getCounterTree(){
                this.$axios.get('/lte/ems/pm/counterManagement/buildCounterManagementTree.html').then((response) => {
                    this.fieldsOfPmCounterTree = {
                        dataSource: response.data,
                        id: 'id',
                        text: 'text',
                        child: 'children',
                        expanded: 'state'
                    };
                });
            }
        },
        mounted() {
            this.getCounterTree();
        }
    }
</script>

<style scoped>

</style>
